import { useCallback, useEffect, useState } from 'react';
import apiClient from '../requests/api/apiClient';
import { NodeSchema } from '../requests/api/apiTypes';

function useNodes(selectedFarmId: string) {
  const [nodes, setNodes] = useState<NodeSchema[]>([]);

  const fetchNodes = useCallback(async () => {
    if (selectedFarmId) {
      try {
        const response = await apiClient.nodes.nodesByFarmId(
          selectedFarmId,
        );
        setNodes(response?.data?.nodes ?? []);
      } catch {
        setNodes([]);
      }
    }
  }, [selectedFarmId]);

  useEffect(() => {
    fetchNodes();
  }, [fetchNodes]);

  return { nodes, refetchNodes: fetchNodes };
}

export default useNodes;
